import mixpanel from 'mixpanel-browser'
import { Userpilot } from 'userpilot'

import useIsTestMode from 'hooks/useIsTestMode'

export function isMixpanelEnabled(): boolean {
    return !!process.env.REACT_APP_MIXPANEL_TOKEN
}

const useMixpanel = () => {
    const isTestMode = useIsTestMode()
    if (!isMixpanelEnabled()) {
        return {
            track: () => {},
            alias: () => {},
        }
    }

    const mode = isTestMode === undefined ? undefined : isTestMode === true ? 'test' : 'live'

    return {
        track: (event: string, properties: Record<string, any> = {}) => {
            mixpanel.track(event, { mode, ...properties })
            // we mirror mixpanel events to userpilot
            Userpilot.track(event)
        },
        alias: (id: string) => {
            mixpanel.alias(id)
        },
    }
}

export default useMixpanel
